import IconButtonLayout from "../layout/IconButtonLayout";

function IconButton ( props ) {

    return <IconButtonLayout {...props} />

}

export default IconButton;
